import React, { useCallback } from 'react';
import _ from 'lodash';

import { MarketingContentFragment } from '@occc/graphql';

import { MarketingContent } from './MarketingContent';

import { Option } from '../../../components/FormSelect';

interface IMarketingContentContainerProps {
  marketingContents: MarketingContentFragment[];
}

export const MarketingContentContainer: React.FC<IMarketingContentContainerProps> = ({
  marketingContents,
}) => {
  const [selectedMarketingContentId, setSelectedMarketingContentId] = React.useState<string>(
    marketingContents[0].id,
  );
  const handleMarketingContentSelect = useCallback(
    (event: React.ChangeEvent<{ value: string }>) => {
      setSelectedMarketingContentId(event.target.value);
    },
    [setSelectedMarketingContentId],
  );
  const options: Option[] = _.map(marketingContents, (item) => ({
    c: item.locale,
    v: item.id,
  }));
  const marketingContent = _.filter(marketingContents, ['id', selectedMarketingContentId])[0];

  return (
    <MarketingContent
      selectedMarketingContent={marketingContent}
      options={options}
      onChange={handleMarketingContentSelect}
      value={selectedMarketingContentId}
    />
  );
};
